"use client";

import { GoogleLogoIcon } from "@/app/assets/icons";
import Button from "@/components/ui/Button";
import { useNotification } from "@/lib/NotificationProvider";
import { useLazyGetGoogleLinkQuery } from "@/store/services";
import { getErrorMessage } from "@/utils/errorUtils";

export default function GoogleAuthButton() {
  const { notifyError } = useNotification();
  const [getGoogleLink, { isLoading }] = useLazyGetGoogleLinkQuery();

  const handleGoogleAuth = async () => {
    try {
      const response = await getGoogleLink().unwrap();
      window.location.assign(response.authUrl);
    } catch (error: unknown) {
      const { message, description } = getErrorMessage(error);
      notifyError({ message, description });
    }
  };

  return (
    <Button
      icon={<GoogleLogoIcon />}
      loading={isLoading}
      disabled={isLoading}
      onClick={handleGoogleAuth}
    >
      Continue with Google
    </Button>
  );
}
